import { makeStyles } from "@material-ui/core/styles";
import { Color } from "../../../constants/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",

    position: "relative",

    width: 296,
    height: 70,

    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 14,
    paddingRight: 14,
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: 296,

    "& #waveform": {
      width: 180,
      paddingLeft: 10,
      paddingRight: 10,
    },

    "& #waveform ::part(cursor)": {
      height: 15,
      borderRadius: "50%",
      backgroundColor: theme.colors.clearMain,
      top: 49,
    },

    "& #waveform ::part(progress)": {
      height: 25,
      borderRadius: 4,
      top: 44,
    },
  },
  duration: {
    position: "absolute",
    bottom: 1,

    ...theme.typography.txtBody3,
    fontFamily: "Roboto, sans-serif",
    color: theme.colors.grey5
  },
  avatarContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    position: "relative",

    width: 45,
    height: 42,

    borderRadius: 50,
  },
  avatarWithInitials: {
    backgroundColor: theme.colors.grey4,
  },
  avatarWithLogo: {
    backgroundColor: theme.colors.clearMain,
  },
  accountLogo: {
    width: 45,
    height: 42,

    borderRadius: 50,
  },
  avatarInitials: {
    ...theme.typography.txtBody1,
    fontWeight: 700,
    color: "#FFFFFF",
  },
  avatarMicrophone: {
    position: "absolute",
    bottom: -5
  }
}));

export default useStyles;
